export default {
  'selector_multiple_component_placeholder': 'Search',
  'selector_multiple_component_overall': 'Overall',
  'selector_multiple_component_select_all': 'Select All',
  'selector_multiple_component_clear_all': 'Clear All',
  'selector_multiple_component_no_data': 'No result found',
  'selector_multiple_component_no': 'No data yet',

  // 自定义筛选器
  'selector_multiple_component_custom_filter_all_describe': 'All',
  // zone
  'selector_multiple_component_zone_label': 'Zone',
  'selector_multiple_component_zone_all_describe': 'All',
  'selector_multiple_component_zone_all_info': 'Display data results based on de-duplicated users for all zones',

  // channel
  'selector_multiple_component_channel_label': 'Channel',
  'selector_multiple_component_channel_all_describe': 'All',
  'selector_multiple_component_channel_all_info': 'Display data results based on de-duplicated users for all channels',
  'selector_multiple_component_channel_all_info_pubgm': 'ALL：Display data results based on de-duplicated users for all channels\n' +
    'Beginning with TP: Taiwan version\n' +
    'Beginning with JPKR: Japanese-Korean version\n' +
    'Beginning with VNG: Vietnam version\n' +
    'Beginning with LITE: Lite version\n' +
    'Beginning with Global: International version\n' +
    'All the above without the Lite version: M version',
  'selector_multiple_component_channel_tips': 'Player login channel',
  'selector_multiple_component_channel_tips_iaa': 'User Source Channel',

  // system
  'selector_multiple_component_system_label': 'Platform',
  'selector_multiple_component_system_all_describe': 'All',
  'selector_multiple_component_system_all_info': 'Display data results based on de-duplicated users for all platforms',
  'selector_multiple_component_system_tips': 'Player login platform',

  // NetWork Type
  'selector_multiple_component_network_label': 'NetWork Type',
  'selector_multiple_component_network_all_describe': 'All',
  'selector_multiple_component_network_all_info': 'Display data results based on de-duplicated users for all network type',

  // Media Channel
  'selector_multiple_component_media_label': 'Media Channel',
  'selector_multiple_component_media_all_describe': 'All',
  'selector_multiple_component_media_all_info': 'Display data results based on de-duplicated users for all media channel',

  // Language Channel
  'selector_multiple_component_language_label': 'Language',
  'selector_multiple_component_language_all_describe': 'All',
  'selector_multiple_component_language_all_info': 'Display data results based on de-duplicated users for all language',
  'selector_multiple_component_language_tips': 'Player register system language',

  'selector_multiple_component_language_label_poe': 'League',
  'selector_multiple_component_language_all_info_poe': 'Display data results based on de-duplicated users for all league',


  // Country
  'selector_multiple_component_country_label': 'Country',
  'selector_multiple_component_country_all_describe': 'All',
  'selector_multiple_component_country_all_info': 'Display data results based on de-duplicated users for all country',

  // Competitor
  'selector_multiple_component_competitor_label': 'Competitor',
  'selector_multiple_component_competitor_all_describe': 'All',

  // APP Version
  'selector_multiple_component_app_version_label': 'APP Version',
  'selector_multiple_component_app_version_all_describe': 'All',
  'selector_multiple_component_app_version_all_info': 'Display data results based on de-duplicated users for all App Version',

  // Memory
  'selector_multiple_component_memory_label': 'Memory',
  'selector_multiple_component_memory_all_describe': 'All',
  'selector_multiple_component_memory_all_info': 'Display data results based on de-duplicated users for all App Memory',

  // Store Channel
  'selector_multiple_component_store_channel_label': 'Store Channel',
  'selector_multiple_component_store_channel_all_describe': 'All',
  'selector_multiple_component_store_channel_all_info': 'Display data results based on de-duplicated users for all Store Channel',

  // Step
  'selector_multiple_component_step_label': 'Step',
  'selector_multiple_component_step_describe': 'All',


  'selector_multiple_component_churn_level_all_info': 'Display data results based on de-duplicated users for all churn level',

  'selector_multiple_component_common_all_describe': 'All',
  'selector_multiple_component_common_all_info': 'Display data results based on de-duplicated users for all {name}',

  'selector_multiple_component_metrics_label': 'Metrics',
  'selector_limit_msg':'The selected metric has reached its limit, please deselect unnecessary metrics first. ',
  'selector_multiple_component_bundle_label': 'Bundle',
}
